
import { UserModule } from '@/store/modules/user';
import { Component, Vue } from 'vue-property-decorator';
import ChangePasswordForm from '@/components/ChangePassword/index.vue';

@Component({
  components: {
    ChangePasswordForm,
  },
})
export default class extends Vue {
  private passwordChangeVisible = false;

  private handlePasswordChangeVisible() {
    this.passwordChangeVisible = !this.passwordChangeVisible;
  }

  private handleLogout() {
    this.$router.push({ name: 'Login', params: { logout: 'true' } }).catch((err) => {
      if (err.name !== 'NavigationDuplicated') {
        console.log('Logout cancelled by route guard.');
      }
    });
  }
}
